<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-alert v-if="hasErrors" type="error"
          >Пользователь с таким логином/паролем не существует</v-alert
        >
        <v-card class="elevation-12">
          <v-toolbar dark class="brg-toolbar">
            <v-toolbar-title>Авторизация</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                v-model="username"
                name="login"
                label="Логин"
                type="text"
                prepend-icon="mdi-account"
                :rules="[rules.required]"
              ></v-text-field>
              <v-text-field
                id="password"
                v-model="password"
                name="password"
                label="Пароль"
                prepend-icon="mdi-lock"
                :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPass ? 'text' : 'password'"
                @click:append="showPass = !showPass"
                :rules="[rules.required]"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-progress-circular
              class="center"
              v-if="showLoader"
              indeterminate
              color="primary"
            ></v-progress-circular>
            <v-btn
              class="brg-btn login center"
              rounded
              large
              v-if="!isSubmitting"
              @click="onSubmit"
            >
              Вход
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "MrmvLogin",
  data: () => ({
    username: "",
    password: "",
    showPass: false,
    rules: {
      required: (value) => !!value || "Обязательно для заполнения",
    },
  }),
  computed: {
    isSubmitting() {
      return this.$store.getters.isLoginFormSubmitting;
    },
    hasErrors() {
      return this.$store.getters.loginErrors;
    },
    showLoader() {
      return this.$store.getters.showLoader;
    },
  },
  methods: {
    onSubmit() {
      this.$store
        .dispatch("login", {
          username: this.username,
          password: this.password,
        })
        .then(() => {
          this.$store.dispatch("get_user_info");
          this.$router.push({ name: "Home" });
        });
    },
  },
};
</script>
